import React, { useEffect, useState } from "react";
import axios from "axios";
import { nodeURL } from "../configUrl";
import { toast } from "react-toastify";
import { normalizeName } from "../utils/similarity";
import { groupBorcRows } from "../utils/cariGrouping";
import FirmaCariModal from "./firmaCari/FirmaCariModal";

const formatTutar = (value) => `${Number(value || 0).toFixed(2)} ₺`;
const formatTarih = (value) => (value ? new Date(value).toLocaleDateString("tr-TR") : "-");

const TahsilatTakibi = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [firmalar, setFirmalar] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expandedFirmaId, setExpandedFirmaId] = useState(null);
  const [cariModalFirma, setCariModalFirma] = useState(null); // { id, name } | null

  const getInfos = () => {
    setLoading(true);
    axios
      .get(`${nodeURL}/getTahsilatTakibi`)
      .then((response) => {
        setFirmalar(response.data);
      })
      .catch(() => {
        toast.error("Tahsilat bilgileri yüklenirken hata oluştu!", { position: "top-right" });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getInfos();
  }, []);

  const toggleExpand = (firmaId) => {
    setExpandedFirmaId((prev) => (prev === firmaId ? null : firmaId));
  };

  const filtered = firmalar.filter((f) => normalizeName(f.name).includes(normalizeName(searchTerm)));
  const gecikmisSayisi = firmalar.filter((f) => f.vadesiGelmisToplam > 0).length;
  const yaklasanSayisi = firmalar.filter((f) => f.vadesiGelmisToplam <= 0 && f.planlananToplam > 0).length;

  return (
    <div
      style={{
        background: "rgba(255, 255, 255, 0.2)",
        borderRadius: "15px",
        padding: "20px",
        backdropFilter: "blur(10px)",
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "10px",
          flexWrap: "wrap",
          gap: "10px",
        }}
      >
        <input
          type="text"
          placeholder="Firma Ara..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{
            padding: "8px",
            border: "1px solid #ccc",
            width: "300px",
            borderRadius: "5px",
          }}
        />
        <h2 className="mt-2" style={{ marginRight: "20px", flexShrink: 0 }}>
          Tahsilat Takibi
        </h2>
        <div className="d-flex gap-2">
          <span className="badge bg-danger" style={{ fontSize: "14px" }}>
            {gecikmisSayisi} gecikmiş
          </span>
          <span className="badge bg-warning text-dark" style={{ fontSize: "14px" }}>
            {yaklasanSayisi} yaklaşan
          </span>
        </div>
      </div>

      {loading ? (
        <div style={{ textAlign: "center", marginTop: "20px", fontSize: "16px" }}>Yükleniyor...</div>
      ) : filtered.length === 0 ? (
        <div
          style={{
            textAlign: "center",
            marginTop: "20px",
            padding: "10px",
            background: "#f8d7da",
            color: "#721c24",
            borderRadius: "5px",
            fontSize: "16px",
          }}
        >
          Borcu olan firma bulunamadı.
        </div>
      ) : (
        <div className="table-responsive">
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr style={{ background: "#f4f4f4", textAlign: "left" }}>
                <th style={{ padding: "10px", borderBottom: "2px solid #ddd" }}>Firma</th>
                <th style={{ padding: "10px", borderBottom: "2px solid #ddd" }}>İlgili Kişi</th>
                <th style={{ padding: "10px", borderBottom: "2px solid #ddd" }}>Tel No</th>
                <th style={{ padding: "10px", borderBottom: "2px solid #ddd" }}>Vadesi Gelmiş Bakiye</th>
                <th style={{ padding: "10px", borderBottom: "2px solid #ddd" }}>Planlanan Borç</th>
                <th style={{ padding: "10px", borderBottom: "2px solid #ddd" }}></th>
              </tr>
            </thead>
            <tbody>
              {filtered.map((f) => (
                <React.Fragment key={f.firma_id}>
                  <tr
                    style={{
                      borderBottom: "1px solid #ddd",
                      backgroundColor: f.vadesiGelmisToplam > 0 ? "#f8d7da" : "#fff3cd",
                    }}
                  >
                    <td style={{ padding: "10px", fontWeight: "bold", cursor: "pointer" }} onClick={() => toggleExpand(f.firma_id)}>
                      {f.name}
                    </td>
                    <td style={{ padding: "10px", cursor: "pointer" }} onClick={() => toggleExpand(f.firma_id)}>
                      {f.ilgili_kisi || "-"}
                    </td>
                    <td style={{ padding: "10px", cursor: "pointer" }} onClick={() => toggleExpand(f.firma_id)}>
                      {f.phone || "-"}
                    </td>
                    <td style={{ padding: "10px", fontWeight: "bold", cursor: "pointer" }} onClick={() => toggleExpand(f.firma_id)}>
                      {f.vadesiGelmisToplam > 0 ? formatTutar(f.vadesiGelmisToplam) : "-"}
                    </td>
                    <td style={{ padding: "10px", cursor: "pointer" }} onClick={() => toggleExpand(f.firma_id)}>
                      {f.planlananToplam > 0 ? formatTutar(f.planlananToplam) : "-"}
                    </td>
                    <td style={{ padding: "10px" }}>
                      <button
                        className="btn btn-sm btn-success"
                        onClick={() => setCariModalFirma({ id: f.firma_id, name: f.name })}
                      >
                        Ödeme Ekle
                      </button>
                    </td>
                  </tr>
                  {expandedFirmaId === f.firma_id && (
                    <tr>
                      <td colSpan={6} style={{ padding: "10px", background: "#fafafa" }}>
                        {f.vadesiGelmisKalemler.length > 0 && (
                          <>
                            <div className="fw-bold mb-1">Vadesi Gelmiş Borç Kalemleri</div>
                            <table className="table table-sm table-bordered mb-3">
                              <thead>
                                <tr>
                                  <th>Ürün</th>
                                  <th>Dönem</th>
                                  <th>Adet</th>
                                  <th>Kalan</th>
                                </tr>
                              </thead>
                              <tbody>
                                {groupBorcRows(f.vadesiGelmisKalemler, { groupByPriceAndDesc: false }).map((g, i) => (
                                  <tr key={i}>
                                    <td>{g.urun_adi}</td>
                                    <td>{formatTarih(g.donem)}</td>
                                    <td>{g.adet}</td>
                                    <td>{formatTutar(g.toplamKalan)}</td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </>
                        )}
                        {f.planlananKalemler.length > 0 && (
                          <>
                            <div className="fw-bold mb-1">Planlanan Borç Kalemleri</div>
                            <table className="table table-sm table-bordered">
                              <thead>
                                <tr>
                                  <th>Ürün</th>
                                  <th>Dönem</th>
                                  <th>Adet</th>
                                  <th>Tutar</th>
                                </tr>
                              </thead>
                              <tbody>
                                {groupBorcRows(f.planlananKalemler, { groupByPriceAndDesc: false }).map((g, i) => (
                                  <tr key={i}>
                                    <td>{g.urun_adi}</td>
                                    <td>{formatTarih(g.donem)}</td>
                                    <td>{g.adet}</td>
                                    <td>{formatTutar(g.toplamTutar)}</td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </>
                        )}
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <FirmaCariModal
        show={!!cariModalFirma}
        onClose={() => {
          setCariModalFirma(null);
          getInfos(); // ödeme eklendiyse tahsilat listesi güncellensin
        }}
        firmaId={cariModalFirma?.id}
        firmaAdi={cariModalFirma?.name}
      />
    </div>
  );
};

export default TahsilatTakibi;
